//User/Auth
export const SYNC_USER = 'SYNC_USER';
export const LOGOUT = 'LOGOUT';
export const CREATE_ACCOUNT = 'CREATE_ACCOUNT';


export const SYNC_USERS = 'SYNC_USERS';

export const SYNC_EXPORTS = 'SYNC_EXPORTS';

export const SYNC_APP_CONFIG = 'SYNC_APP_CONFIG';
export const UPDATE_APP_CONFIG = 'UPDATE_APP_CONFIG';
export const UPDATE_APP_CONFIG_COMPLETE = 'UPDATE_APP_CONFIG_COMPLETE';
export const FETCH_ASSESSMENT_VERSIONS = 'FETCH_ASSESSMENT_VERSIONS';
export const UPDATE_ASSESSMENT_VERSIONS = 'UPDATE_ASSESSMENT_VERSIONS';
export const UPDATE_ASSESSMENT_VERSIONS_COMPLETE = 'UPDATE_ASSESSMENT_VERSIONS_COMPLETE';

export const FETCH_ORG_CONFIG = 'FETCH_ORG_CONFIG';

//Localizations
export const SYNC_LOCALIZATIONS = 'SYNC_LOCALIZATIONS';
export const ACTIVATE_LOCALIZATION = 'ACTIVATE_LOCALIZATION';
export const ACTIVATE_LOCALIZATION_SUCCESS = 'ACTIVATE_LOCALIZATION_SUCCESS';
export const ACTIVATE_LOCALIZATION_ERROR = 'ACTIVATE_LOCALIZATION_ERROR';

//Assessments
export const FETCH_MY_ASSESSMENTS = 'FETCH_MY_ASSESSMENTS';
export const FETCH_MY_ASSESSMENTS_SUCCESS = 'FETCH_MY_ASSESSMENTS_SUCCESS';
export const FETCH_MY_ASSESSMENTS_ERROR = 'FETCH_MY_ASSESSMENTS_ERROR';
export const UPDATE_ASSESSMENT = 'UPDATE_ASSESSMENT';
export const UPDATE_ASSESSMENT_SUCCESS = 'UPDATE_ASSESSMENT_SUCCESS';
export const UPDATE_ASSESSMENT_ERROR = 'UPDATE_ASSESSMENT_ERROR';
export const SCORE_ASSESSMENT = 'SCORE_ASSESSMENT';
export const SCORE_ASSESSMENT_SUCCESS = 'SCORE_ASSESSMENT_SUCCESS';
export const SCORE_ASSESSMENT_ERROR = 'SCORE_ASSESSMENT_ERROR';

export const FETCH_ASSESSMENT_CONFIG = 'FETCH_ASSESSMENT_CONFIG';
export const SYNC_ASSESSMENT_CONFIGS = 'SYNC_ASSESSMENT_CONFIGS';

//Users
export const BEGIN_EDITING_USER = 'BEGIN_EDITING_USER';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';
export const SAVE_USER_ERROR = 'SAVE_USER_ERROR';
export const INVITE_USER = 'INVITE_USER';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_ERROR = 'INVITE_USER_ERROR';
export const END_EDITING_USER = 'END_EDITING_USER';
export const VIEW_USER = 'VIEW_USER';
export const VIEW_USER_SUCCESS = 'VIEW_USER_SUCCESS';
export const VIEW_USER_ERROR = 'VIEW_USER_ERROR';

//Accounts (saved from SF - fetched as needed)
export const SF_ACCOUNT_FOR_DEAL_FETCHED = 'SF_ACCOUNT_FOR_DEAL_FETCHED';

//Teams
export const SYNC_TEAMS = 'SYNC_TEAMS';
export const BEGIN_EDITING_TEAM = 'BEGIN_EDITING_TEAM';
export const SAVE_TEAM = 'SAVE_TEAM';
export const SAVE_TEAM_SUCCESS = 'SAVE_TEAM_SUCCESS';
export const SAVE_TEAM_ERROR = 'SAVE_TEAM_ERROR';
export const END_EDITING_TEAM = 'END_EDITING_TEAM';

export const FETCH_TEAMS = 'FETCH_TEAMS';
export const FETCH_TEAMS_SUCCESS = 'FETCH_TEAMS_SUCCESS';
export const FETCH_TEAMS_ERROR = 'FETCH_TEAMS_ERROR';

//Organization Goals
export const BEGIN_EDITING_GOALS = 'BEGIN_EDITING_GOALS';
export const SAVE_GOALS = 'SAVE_GOALS';
export const SAVE_GOALS_SUCCESS = 'SAVE_GOALS_SUCCESS';
export const SAVE_GOALS_ERROR = 'SAVE_GOALS_ERROR';
export const END_EDITING_GOALS = 'END_EDITING_GOALS';

//Velocity Sprint
//for now just fetch all cards at once to allow for reporting / paging w/o additional queries
//TODO paginate this data once we accumulate a lot of it
//all
export const FETCH_SPRINT_DATA = 'FETCH_SPRINT_DATA';
export const FETCH_SPRINT_DATA_SUCCESS = 'FETCH_SPRINT_DATA_SUCCESS';
export const FETCH_SPRINT_DATA_ERROR = 'FETCH_SPRINT_DATA_ERROR';
export const SAVE_SPRINT = 'SAVE_SPRINT';
export const SAVE_SPRINT_SUCCESS = 'SAVE_SPRINT_SUCCESS';
export const SAVE_SPRINT_ERROR = 'SAVE_SPRINT_ERROR';
//admin
export const SAVE_SPRINT_OPTIONS = 'SAVE_SPRINT_OPTIONS';
export const SAVE_SPRINT_OPTIONS_SUCCESS = 'SAVE_SPRINT_OPTIONS_SUCCESS';
export const SAVE_SPRINT_OPTIONS_ERROR = 'SAVE_SPRINT_OPTIONS_ERROR';

export const FETCH_SPRINT_HISTORY = 'FETCH_SPRINT_HISTORY';
export const FETCH_SPRINT_HISTORY_SUCCESS = 'FETCH_SPRINT_HISTORY_SUCCESS';
export const FETCH_SPRINT_HISTORY_ERROR = 'FETCH_SPRINT_HISTORY_ERROR';

//Talent Evaluations
export const FETCH_TALENT_EVALUATIONS = 'FETCH_TALENT_EVALUATIONS';
export const FETCH_TALENT_EVALUATIONS_SUCCESS = 'FETCH_TALENT_EVALUATIONS_SUCCESS';
export const FETCH_TALENT_EVALUATIONS_ERROR = 'FETCH_TALENT_EVALUATIONS_ERROR';

export const SAVE_TALENT_EVALUATION = 'SAVE_TALENT_EVALUATION';
export const SAVE_TALENT_EVALUATION_SUCCESS = 'SAVE_TALENT_EVALUATION_SUCCESS';
export const SAVE_TALENT_EVALUATION_ERROR = 'SAVE_TALENT_EVALUATION_ERROR';

//Talent Evalutions (new) - 180s
export const FETCH_SALES_COMPETENCY_REVIEW_ITEMS = 'FETCH_SALES_COMPETENCY_REVIEW_ITEMS';
export const FETCH_SALES_COMPETENCY_REVIEWS = 'FETCH_SALES_COMPETENCY_REVIEWS';
export const FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS = 'FETCH_SALES_COMPETENCY_REVIEWS_SUCCESS';
export const FETCH_SALES_COMPETENCY_REVIEWS_ERROR = 'FETCH_SALES_COMPETENCY_REVIEWS_ERROR';
export const SAVE_SALES_COMPETENCY_REVIEW = 'SAVE_SALES_COMPETENCY_REVIEW';
export const SAVE_SALES_COMPETENCY_REVIEW_SUCCESS = 'SAVE_SALES_COMPETENCY_REVIEW_SUCCESS';
export const SAVE_SALES_COMPETENCY_REVIEW_ERROR = 'SAVE_SALES_COMPETENCY_REVIEW_ERROR';
export const FETCH_SALES_COMPETENCY_REVIEW = 'FETCH_SALES_COMPETENCY_REVIEW';
export const FETCH_SALES_COMPETENCY_REVIEW_SUCCESS = 'FETCH_SALES_COMPETENCY_REVIEW_SUCCESS';
export const FETCH_SALES_COMPETENCY_REVIEW_ERROR = 'FETCH_SALES_COMPETENCY_REVIEW_ERROR';

//Deals
export const FETCH_DEAL = 'FETCH_DEAL';
export const FETCH_DEAL_SUCCESS = 'FETCH_DEAL_SUCCESS';
export const FETCH_DEAL_ERROR = 'FETCH_DEAL_ERROR';
export const SAVE_DEAL = 'SAVE_DEAL';
export const SAVE_DEAL_SUCCESS = 'SAVE_DEAL_SUCCESS';
export const SAVE_DEAL_ERROR = 'SAVE_DEAL_ERROR';
export const FETCH_DEALS = 'FETCH_DEALS';
export const FETCH_DEALS_SUCCESS = 'FETCH_DEALS_SUCCESS';
export const FETCH_DEALS_ERROR = 'FETCH_DEALS_ERROR';

//Employees
//export const FETCH_EMPLOYEE_DATA = 'FETCH_EMPLOYEE_DATA';

// export const UPDATE_USER_BEGIN = 'UPDATE_USER_BEGIN';
// export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';
// export const UPDATE_USER_FAIL = 'UPDATE_USER_FAIL';

export const SYNC_ORGANIZATION = 'SYNC_ORGANIZATION';
export const SYNC_EMPLOYEES = 'SYNC_EMPLOYEES';


//Super admins
export const SYNC_ORGANIZATIONS = 'SYNC_ORGANIZATIONS';



// WEBPACK FOOTER //
// ./src/actions/types.js